import { Dispatch, SetStateAction, useState } from 'react';

export const FILTER_OPERATOR = {
  IN: 'IN',
} as const;

export type MapLayerFilter = {
  key: string;
  value: string[];
  filter: string;
};

export const DEFAULT_MAP_LAYER_FILTER: MapLayerFilter = {
  key: '',
  value: [],
  filter: '',
};

export type SetMapLayerFilter = Dispatch<SetStateAction<MapLayerFilter>>;

export const useMapLayerFilter = () => {
  const [filter, setFilter] = useState<MapLayerFilter>({ ...DEFAULT_MAP_LAYER_FILTER });

  return {
    filter,
    setFilter,
  };
};

export const handleFilterUpdate = ({
  filterKey,
  filterValue,
  filterOperator,
  setFilters,
}: {
  filterKey: string;
  filterValue: string[];
  filterOperator: (typeof FILTER_OPERATOR)[keyof typeof FILTER_OPERATOR];
  setFilters: SetMapLayerFilter;
}) => {
  if (!filterValue || !Array.isArray(filterValue) || filterValue.length === 0) {
    setFilters({
      ...DEFAULT_MAP_LAYER_FILTER,
    });
    return;
  }

  const filter = `${filterKey} ${filterOperator} ('${filterValue.join("','")}')`;

  setFilters({
    key: filterKey,
    value: filterValue,
    filter,
  });
};
